export default "__VITE_ASSET__BeVKz5u___"